// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pdocEntity from './entities/pdoc.json';
import pdocMenu from '../pages/pdoc/menu.json';
import pdocFullForm from '../pages/pdoc/forms/full.json';
import pdocContextForm from '../pages/pdoc/forms/context.json';
import pdocTableView from '../pages/pdoc/views/table.json';
import pdocStagesView from '../pages/pdoc/views/stages.json';
import pdocCardsView from '../pages/pdoc/views/cards.json';
import pdocInlineView from '../pages/pdoc/views/inline.json';
import pdocBacklogView from '../pages/pdoc/views/backlog.json';
import pdocSplitView from '../pages/pdoc/views/split.json';
import pdocCalendarView from '../pages/pdoc/views/calendar.json';
import pdocDashboardView from '../pages/pdoc/views/dashboard.json';

/** Тип запису «Ознайомлення з документом» зі сторінками пакета: меню, форми та подання з pages/pdoc/. */
export const pdocDefinition: IRecordTypeDefinition = {
  ...pdocEntity,
  views: assembleViewSet({
      table: pdocTableView,
      stages: pdocStagesView,
      cards: pdocCardsView,
      inline: pdocInlineView,
      backlog: pdocBacklogView,
      split: pdocSplitView,
      calendar: pdocCalendarView,
      dashboard: pdocDashboardView,
  }),
  form: pdocFullForm,
  forms: { full: pdocFullForm, context: pdocContextForm },
  menu: pdocMenu,
} as IRecordTypeDefinition;
